var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cityListWrapper"},[_c('Section',{attrs:{"title":"職涯之⾏・世界之旅","data":_vm.cityList,"noDataText":"尚無熱門徵才城市"}},[_c('CarouselHomeCarousel',{attrs:{"list":_vm.cityList,"type":"city"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }